import { useEffect, useState } from "react";
import { Rocket, AlertTriangle, Check, ArrowRight } from "lucide-react";
import { client } from "@/lib/api";

export function LaunchReadiness({ onGoTo }) {
  const [data, setData] = useState(null);
  useEffect(() => { client.get("/admin/launch-readiness").then(r => setData(r.data)).catch(() => {}); }, []);
  if (!data) return <p className="muted">Yükleniyor…</p>;
  return <div data-testid="launch-readiness-panel">
    <div className="table-title"><h2><Rocket size={18} /> Yayına hazırlık · Eksik bilgiler</h2><span data-testid="launch-progress">{data.ready}/{data.total} tamamlandı</span></div>
    <div className="notice" data-testid="launch-notice"><AlertTriangle size={14} /> Bu liste yalnızca <b>dışarıdan gelmesi gereken</b> bilgileri toplar. Ödeme modu: {data.payment_mode === "live" ? "CANLI" : "TEST"}. Metin sürümü: {data.legal_version}. Bu ekrandaki bilgiler kayıtlı ayarlardan alınır.</div>
    <div className="launch-list">
      {data.items.map(i => <article className={i.status === "ok" ? "launch-item ok" : "launch-item"} key={i.id} data-testid={`launch-item-${i.id}`}>
        <span className="launch-state" data-testid={`launch-state-${i.id}`}>{i.status === "ok" ? <Check size={15} /> : <AlertTriangle size={15} />}</span>
        <div>
          <strong>{i.title}</strong>
          <small>{i.detail}</small>
          <small className="muted" data-testid={`launch-evidence-${i.id}`}>Mevcut durum: {i.evidence}</small>
        </div>
        <button className="btn ghost small" onClick={() => onGoTo(i.tab)} data-testid={`launch-goto-${i.id}`}>{i.tab === "settings" ? "Ayarlar" : i.tab === "documents" ? "Dokümanlar" : "Yayın Kontrolü"} <ArrowRight size={13} /></button>
      </article>)}
    </div>
  </div>;
}
